import { DataHeader, DataSource, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelReimbursementRate extends Layout {
    dataheaderFuelReimbursementRate: DataHeader;
    panelContent: Panel;
    sourceFuelPayrate: DataSource;
    sourceFuelReimbursement: DataSource;
    switchActive: Switch;
    tableFuelPayRate: Table;
    textboxDeductCode: Textbox;
    textboxId: Textbox;
}
